import { render, staticRenderFns } from "./taxon-select.vue?vue&type=template&id=00df6eba&"
import script from "./taxon-select.vue?vue&type=script&lang=js&"
export * from "./taxon-select.vue?vue&type=script&lang=js&"
import style0 from "./taxon-select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports